import * as z from 'zod'

import { LocalStorage, loadStorage, removeStorage, saveStorage } from '@/common/util/storage'

export const loginSchema = z.object({
  projectNumber: z.string().min(1),
  email: z.string().min(1),
  password: z.string().min(1),
  // プロジェクト番号とメールアドレスを LocalStorage に記憶するか
  remember: z.boolean()
})

export type LoginFormSchemaType = z.infer<typeof loginSchema>

export const REMEMBERED_LOGIN_DEFAULT = {
  projectNumber: '',
  email: ''
}

/** LocalStorage に記憶したプロジェクト番号・メールアドレスを読み出す（無ければ null）。 */
export const loadRememberedLogin = (): { projectNumber: string; email: string } | null => {
  const raw = loadStorage(LocalStorage.LOGIN_REMEMBER)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw)
    return {
      projectNumber: typeof parsed.projectNumber === 'string' ? parsed.projectNumber : '',
      email: typeof parsed.email === 'string' ? parsed.email : ''
    }
  } catch {
    return null
  }
}

/** remember が ON のとき記憶し、OFF のとき削除する。 */
export const saveRememberedLogin = (
  remember: boolean,
  values: { projectNumber: string; email: string }
) => {
  if (remember) {
    saveStorage(
      LocalStorage.LOGIN_REMEMBER,
      JSON.stringify({ projectNumber: values.projectNumber, email: values.email })
    )
  } else {
    removeStorage(LocalStorage.LOGIN_REMEMBER)
  }
}
